import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode } from '../../../../classes';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent implements OnInit, OnDestroy {
	_debug:true;
	currentNode:MenuNode=null;
	debug(msg:string){
		if(this._debug){
			console.log("TextComponent: "+msg);
		}
	}
	handleEvent(event){
		this.debug("Incoming event:" +event);
		switch(event){
			case 'confirm':{

				let node = this.menuService.getCurrentNode().getTargetNode();
				this.menuService.getCurrentNode().onConfirm(undefined);
				if(node){
					this.menuService.goto(node);
					return;
				}
				break;
			}
			case 'back':{
				
	        if(this.menuService.getCurrentNode().hasBackTarget()){
	            console.log("Goto backtarget ");
	            let backTarget = this.menuService.getCurrentNode().getBackTargetNode()
	            
	            console.log("Backtarget is: "+backTarget.getTitle());
	            this.menuService.goto(backTarget);
	            return;

	        }
				this.menuService.hierarchyUp();
				return;
			}
			default:{
				this.debug("Unable to handle event:" +event);
			}
		}
	}
  constructor(private menuService:MenuService, private ioService:DataIoService) { 
  	this.currentNode = this.menuService.getCurrentNode();
  }
  eventSubscription:any;
  ngOnInit() {
  	this.eventSubscription = this.ioService.inputs.events$.subscribe( (event)=>{this.handleEvent(event);});
  }	
  ngOnDestroy(){
  	this.eventSubscription.unsubscribe();
  }
  getTitle(){
  	return this.currentNode.getTitle();
  }
  getText(idx:number):string{
  	return this.currentNode.getText(idx);
  }
  hasParameter(p:string):boolean{
  	return this.currentNode.hasParameter(p);
  }
}
